const preventInputNumberOnWheel = (e) => {
  const inputType = e?.target?.type;

  // Just trigger this code on input number
  if (inputType === 'number') {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  }
};

export default preventInputNumberOnWheel;
